import { brand } from './tokens.js';
/**
 * The brand mark on its 32 × 32 grid: a leaf over a rounded teal tile, with a stem and a ring.
 * The web application draws it from these shapes; the Keycloak theme writes it as an SVG file and
 * rasterises it for e-mails.
 */
export const brandMark = {
    size: 32,
    tile: { rx: 9, fill: brand.primary },
    leaf: { d: 'M9 18.5c0-5 3.5-9 10-10.5-.8 6.8-4.2 11-9.2 11.6', fill: '#99f6e4' },
    stem: { d: 'M10 22l4.5-6', stroke: '#ecfeff', strokeWidth: 1.8 },
    ring: { cx: 21.5, cy: 21.5, r: 3, stroke: '#ecfeff', strokeWidth: 1.8 },
};
/** The mark as a standalone SVG document. */
export function brandMarkSvg(size = brandMark.size) {
    const { tile, leaf, stem, ring } = brandMark;
    const grid = brandMark.size;
    return [
        `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${grid} ${grid}">`,
        `<rect width="${grid}" height="${grid}" rx="${tile.rx}" fill="${tile.fill}"/>`,
        `<path d="${leaf.d}" fill="${leaf.fill}"/>`,
        `<path d="${stem.d}" fill="none" stroke="${stem.stroke}" stroke-width="${stem.strokeWidth}" stroke-linecap="round"/>`,
        `<circle cx="${ring.cx}" cy="${ring.cy}" r="${ring.r}" fill="none" stroke="${ring.stroke}" stroke-width="${ring.strokeWidth}"/>`,
        '</svg>',
    ].join('');
}
//# sourceMappingURL=mark.js.map